<span class="td-wb-button__content">
  <ng-content />
</span>
@if (showSpinner()) {
<td-wb-spinner class="td-wb-button__spinner-icon" />
}
